import GoogleDriveApi from './google_drive.api';
import OneDriveApi from './one_drive.api';
import DropboxApi from './dropbox.api';
import BoxApi from './box.api';
import CommondriveApi from 'Api/common_drive.api';
import { store } from '@store/index'
import { toJS } from 'mobx';
import { isAzk8sByDomain, isPdfOnlineDomain, prop } from '@utils/utils'
import { iManage } from './drives.constants';
import { iManageService } from '@/store/services';
import { iManageApi } from './index';
const googleDriveApi = new GoogleDriveApi();
const oneDriveApi = new OneDriveApi();
const dropboxApi = new DropboxApi();
const boxApi = new BoxApi();
const commonDriveApi = new CommondriveApi()

export function signInForGSuite(success) {
  googleDriveApi.signInForGSuite(success);
}
export function redirectToGoogleOAuth(fileParams) {
  googleDriveApi.redirectToGoogleOAuth(fileParams);
}
export function signIn(driveName, success, fail, closeWin) {

  switch (driveName) {
    case 'Google Drive':
      googleDriveApi.signIn(success, closeWin, fail);
      break;
    case 'OneDrive':
      oneDriveApi.signIn(success, closeWin, fail);
      break;
    case 'Box':
      boxApi.signIn(success, closeWin, fail);
      break;
    case 'DropBox':
      dropboxApi.signIn(success, closeWin, fail);
      break;
    case iManage:
      iManageService.loginIManage(success, closeWin, fail)
      break;
    default:
      commonDriveApi.signIn(driveName,success,closeWin,fail);
      break;
    }
}
export function getUserInfo(driveName, success, fail) {
  switch (driveName) {
  case 'Google Drive':
    googleDriveApi.getUserInfo(success, fail);
    break;
  case 'OneDrive':
    oneDriveApi.getUserInfo(success, fail);
    break;
  case 'Box':
    boxApi.getUserInfo(success, fail);
    break;
  case 'DropBox':
    dropboxApi.getUserInfo(success, fail);
    break;
    default:
      commonDriveApi.getUserInfo(driveName,success,fail);
    break;
  }
}
export function signOut(driveName, success, fail) {
  switch (driveName) {
    case 'Google Drive':
      googleDriveApi.signOut(success, fail);
      break;
    case 'OneDrive':
      oneDriveApi.signOut(success, fail);
      break;
    case 'Box':
      boxApi.signOut(success, fail);
      break;
    case 'DropBox':
      dropboxApi.signOut(success, fail);
      break;
    case iManage:
      iManageService.loginOut(success, fail);
      break;
    default:
      commonDriveApi.signOut(driveName, success, fail);
      break;
    }
}
export function getItems(driveName, folderId, success, fail) {
  switch (driveName) {
    case 'Google Drive':
      googleDriveApi.getItems(folderId, success, fail);
      break;
    case 'OneDrive':
      oneDriveApi.getItems(folderId, success, fail);
      break;
    case 'Box':
      boxApi.getItems(folderId, success, fail);
      break;
    case 'DropBox':
      dropboxApi.getItems(folderId, success, fail);
      break;
    default:
      commonDriveApi.getItems(driveName,folderId,success,fail);
      break;
    }
}
export function downloadFileWithUrl(driveName, item, success, fail) {
  switch (driveName) {
    case 'Google Drive':
      googleDriveApi.downloadFile(item, success, fail);
      break;
    case 'OneDrive':
      oneDriveApi.downloadFile(item, success, fail);
      break;
    case 'Box':
      boxApi.downloadFile(item, success, fail);
      break;
    case 'DropBox':
      dropboxApi.downloadFile(item, success, fail);
      break;
    case iManage:
      iManageApi.downloadFile(item, success, fail);
      break;
    default:
      commonDriveApi.downloadFile(driveName,item,success,fail);
      break;
    }
}
export function updateFile(driveName, item, file, success, fail, progress,mimeType) {
  switch (driveName) {
    case 'Google Drive':
      return googleDriveApi.updateFileSimpleUpload(item.id, file, success, fail, progress,mimeType);
    case 'OneDrive':
      // oneDriveApi.updateFile(item.id, file, success, fail, progress);
      break;
    case 'Box':
      boxApi.updateFile(item.id, file, success, fail, progress);
      break;
    case 'DropBox':
      dropboxApi.updateFile(item, file, success, fail, progress);
      // updateFileDropBox(item, file, success, fail, progress);
      break;
    default:
      commonDriveApi.updateFileSimpleUpload(driveName, item, file, success, fail, progress,mimeType);
      break;
    }
}
export function createFile({driveName, fileBlob: file, folderPath, success, fail, progress, mimeType, fileType, libraryName, folderId, doc_profile}) {
  switch (driveName) {
    case 'Google Drive':
      return googleDriveApi.createFileMultipart(file, folderPath, success, fail, progress, mimeType, fileType);
    case 'OneDrive':
      oneDriveApi.createFileWithUploadSession(file, folderPath, success, fail, progress);
      break;
    case 'Box':
      boxApi.createFile(file, folderPath, success, fail, progress);
      break;
    case 'DropBox':
      dropboxApi.createFile(file, folderPath, success, fail, progress);
      break;
    case iManage:
      return iManageApi.createFile({libraryName, folderId, doc_profile, file});
      break;
    default:
      commonDriveApi.createFile(driveName,file,folderPath,success,fail,progress,mimeType,fileType);
      break;
    }
}
export async function uploadFileToSharepoint(requestData) {
  return oneDriveApi.uploadFileToSharepoint(requestData)
}

export async function isSignInDrive(driveName) {
  let isSignIn;

  switch (driveName) {
    case 'Google Drive':
      isSignIn = await googleDriveApi.isSignIn();
      break;
    case 'OneDrive':
      isSignIn = oneDriveApi.isSignIn();
      break;
    case 'Box':
      isSignIn = boxApi.isSignIn();
      break;
    case 'DropBox':
      isSignIn = dropboxApi.isSignIn();
      break;
    case iManage:
      isSignIn = iManageService.isSignIn()
      break;
    default:
      isSignIn = commonDriveApi.isSignIn(driveName);
      break;
    }

  return isSignIn;
}

export async function initTokenByRefreshToken({driveName,refreshToken}){
    let res=null;
    switch (driveName) {
        case 'Google Drive':
            res = await googleDriveApi.reBuildTokenByRefreshToken(refreshToken);
            break;
    }
    return res;
}

export function isDownloadFilePending(driveName) {
  let result;

  switch (driveName) {
    case 'Google Drive':
      result = googleDriveApi.downloadFileRequest;
      break;
    case 'OneDrive':
      result = oneDriveApi.downloadFileRequest;
      break;
    case 'Box':
      result = boxApi.downloadFileRequest;
      break;
    case 'DropBox':
      result = dropboxApi.downloadFileRequest;
      break;
    default:
      break;
    }

  return result;
}
export function isUploadFilePending(driveName) {
  let result;

  switch (driveName) {
    case 'Google Drive':
      result = googleDriveApi.uploadFileRequest;
      break;
    case 'OneDrive':
      result = oneDriveApi.uploadFileRequest;
      break;
    case 'Box':
      result = boxApi.uploadFileRequest;
      break;
    case 'DropBox':
      result = dropboxApi.uploadFileRequest;
      break;
    default:
      break;
    }

  return result;
}
export function isUpdateFilePending(driveName) {
  let result;

  switch (driveName) {
    case 'Google Drive':
      result = googleDriveApi.updateFileRequest;
      break;
    case 'OneDrive':
      // result = uploadFileRequestOneDrive;
      break;
    case 'Box':
      result = boxApi.updateFileRequest;
      break;
    case 'DropBox':
      // result = uploadFileRequestDropBox;
      break;
    default:
      break;
    }

  return result;
}
export function cancelPendingRequest(driveName) {
  switch (driveName) {
    case 'Google Drive':
      // cancelDownloadFileGoogleDrive();
      // cancelUploadFileGoogleDrive();
      break;
    case 'OneDrive':
      // cancelDownloadFileOneDrive();
      // cancelUploadFileOneDrive();
      break;
    case 'Box':
      // isSignIn = isSignInBox();
      break;
    case 'DropBox':
      // cancelDownloadFileDropBox();
      // cancelUploadFileDropBox();
      break;
    default:
      break;
    }
}
export function cancelOpenFileRequest(driveName) {
  switch (driveName) {
    case 'Google Drive':
      googleDriveApi.cancelDownloadFile();
      break;
    case 'OneDrive':
      oneDriveApi.cancelDownloadFile();
      break;
    case 'Box':
      boxApi.cancelDownloadFile();
      break;
    case 'DropBox':
      dropboxApi.cancelDownloadFile();
      break;
    default:
      break;
    }
}
export function cancelUploadFileRequest(driveName) {
  switch (driveName) {
    case 'Google Drive':
      googleDriveApi.cancelUploadFile();
      break;
    case 'OneDrive':
      oneDriveApi.cancelUploadFile();
      break;
    case 'Box':
      boxApi.cancelUploadFile();
      break;
    case 'DropBox':
      dropboxApi.cancelUploadFile();
      break;
    default:
      break;
    }
}
export function cancelUpdatedFileRequest(driveName) {
  switch (driveName) {
    case 'Google Drive':
      googleDriveApi.cancelUpdatedFile();
      break;
    case 'OneDrive':
      break;
    case 'Box':
      boxApi.cancelUpdatedFile();
      break;
    case 'DropBox':
      break;
    default:
      break;
    }
}
export function getOneDriveFileByUrl(shareUrl,success,fail) {
  oneDriveApi.getOneDriveFileByUrl(shareUrl,success,fail);
}
export function getFileFromFileHandler(url, token) {
  return oneDriveApi.getFileFromFileHandler(url, token)
}
export function getFileHandlerState(stateId) {
  return oneDriveApi.getFileHandlerState(stateId)
}
export function refreshTokenForSharePoint() {
  let client_id
  let client_secret

  if (prop(location, "host").indexOf('localhost') > -1) {
    client_id = "a8affa67-207b-4506-86f2-5fd71ce1192c"
    client_secret = "gDa7Q~Kd3wpFph_GsyRLdPieOKOySXnDCkFrG"
  } else if (isAzk8sByDomain()) {
    client_id = "57dc8684-78e7-4665-b473-a523dad802c7"
    client_secret = "rx~c.1d79caZG57-FO_0a0G_iD3DfDXGP-"
  } else if (isPdfOnlineDomain()) {
    client_id = "c1f97a40-ca8d-4b18-ac70-cd2f6ab513f2"
    client_secret = "v6N8Q~qcFEeOnIok3gt3JbUuON0je20UaHuvScNx"
  }

  store.driveStore.updateSharePointRefreshTokenInfo({client_id, client_secret})

  const { sharePointRefreshTokenInfo } = store.driveStore

  return oneDriveApi.refreshTokenForSharePoint(toJS(sharePointRefreshTokenInfo))
}
export function webHookSubscribeForSharePoint() {
  return oneDriveApi.webHookSubscribeForSharePoint()
}

export function getFileMetaData(params) {
  return oneDriveApi.getFileMetaData(params)
}

export function createFolder({driveName, folderName, folderPath}) {
  switch (driveName) {
    case 'Google Drive':
      return googleDriveApi.createFolder({folderName, folderPath});
    case 'OneDrive':
      return oneDriveApi.createFolder({folderName, folderPath})
    case 'Box':
      return boxApi.createFolder({folderName, folderPath})
    case 'DropBox':
      return dropboxApi.createFolder({folderName, folderPath})
    default:
      break;
    }
}

export function listFolder({driveName,folderName,parentId}) {
  switch (driveName){
    case 'Google Drive':
      return googleDriveApi.listFolder({folderName,parentId});
    // todo
    // case 'OneDrive':
    //   return oneDriveApi.listFolder({folderName, folderPath})
    // case 'Box':
    //   return boxApi.listFolder({folderName, folderPath})
    // case 'DropBox':
    //   return dropboxApi.listFolder({folderName, folderPath})
    // default:
    //   break;
  }
}

export function listFiles({driveName,parentId,fileName}) {
  switch (driveName){
    case 'Google Drive':
      return googleDriveApi.listFiles({parentId,fileName});
    // todo
    // case 'OneDrive':
    //   return oneDriveApi.listFiles({folderName, folderPath})
    // case 'Box':
    //   return boxApi.listFiles({folderName, folderPath})
    // case 'DropBox':
    //   return dropboxApi.listFiles({folderName, folderPath})
    // default:
    //   break;
  }
}
